export const Attribution = ({ chair, className = "", linked = true }) => (
  <p className={`text-xs text-muted-foreground ${className}`} data-testid="attribution-line">
    Source:{" "}
    {linked ? (
      <a
        href={chair.source_url}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 hover:text-accent transition-colors"
        data-testid="attribution-source-link"
      >
        {chair.source_name}
      </a>
    ) : (
      <span className="underline underline-offset-2">{chair.source_name}</span>
    )}
    {chair.license ? ` \u2022 ${chair.license}` : ""}
  </p>
);
